import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { defaultDateConfig } from './defaultDateConfig';
/**
 * Formats date using default config and a custom format string.
 * Consider using `formatDate` or `formatDateTime` instead of this.
 * @param {Date }date - Date to format.
 * @param {string} formatString - Format string, see https://date-fns.org/v2.30.0/docs/format.
 * @param {string} timeZone - Optional time zone, if not set default from `defaultDateConfig.timeZone` is used.
 * @returns {string} The formatted date string.
 */
export function formatDateCustom(date, formatString, timeZone) {
    timeZone !== null && timeZone !== void 0 ? timeZone : (timeZone = defaultDateConfig.timeZone);
    if (timeZone) {
        return formatInTimeZone(date, timeZone, formatString, defaultDateConfig.formatOptions);
    }
    else {
        return format(date, formatString, defaultDateConfig.formatOptions);
    }
}
